<section id="seguro" class="video-section  bg-color-white bg-mobile">
  <div id="carouselExampleControls-seguro" class="carousel slide  " data-interval="false">
    <div class="carousel-inner">
      <div class="carousel-item active" style="    width: 99.354vw !important;">
        <div class="container-fluid p-0">
          <img src="../../../../../assets/app-assets/images/fotografias/varejo/banner-botton.png"
            class="img-fluid w-100" alt="Banner Full">

          <div class="card-overlay justify-content-center card-simule" style="margin-top: 200px;">
            <div class="card card-seguro ">
              <div class="card-body">
                <div class=" mt-div-banner-title-on-mobile">

                  <div class="text-center container">
                    <h2 class="title-card-master title-banner title preto-geia l-s-0">
                      SUA SEGURANÇA PARA <span class="sub-title-card-master title sub-title-banner l-s-0"
                        style="color: #023341 !important;">VIVER COM</span><br>
                      <span class="sub-title-card-master title sub-title-banner l-s-0">TRANQUILIDADE</span>
                    </h2>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <a class="icon-carrousel-bg-left carousel-control-prev" href="#carouselExampleControls-seguro" role="button"
      data-slide="prev">
      <span class="carousel-control-prev-icon icon-prev-left icon-style " aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleControls-seguro" role="button" data-slide="next" style="
    margin-right: 35px !important; background-color: transparent;">
      <span class="carousel-control-next-icon icon-style" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
</section>
<!-- <section class=" about-section mt-5  bg-grey" style="padding-top: 21px;"> -->
<!-- <app-auto-slider-bottom [receberSliderItems]="sliderItemsSeguro"></app-auto-slider-bottom> -->

<!-- </section> -->
<section class="feature-medicine-section mt-4" style="background-color: #f2f2f2 0% 0% no-repeat padding-box">
  <div class="container">
    <div class="row container  ">
      <div class="row align-items-center">
        <div class="col-lg-7 mb-2">
          <div class="section-heading heading-white">
            <span class="subt-title-left span-30px">Seguros que cabem </span>
            <h2 class="title-left" style="line-height: 1.4">no seu bolso</h2>
            <span class="subt-title-left span-28px"
              style="line-height: 1.4 !important;font-weight: 600!important;font-size: 15px !important;">RELACIONAMENTO
              CONTÍNUO E
              ASSISTÊNCIA QUANDO
              PRECISAR</span>
          </div>
        </div>
        <div class="col-lg-5">

        </div>
      </div>

      <div class="container">
        <div class="row">
          <div id="carousel-seguro" class="carousel slide" data-interval="false" data-ride="carousel">

            <div class="carousel-inner-">
              <div class="carousel-item active">
                <div class="d-none d-lg-block d-md-block">

                  <div class="cards-wrapper">
                    <div class="card   shadow-card " style="width:60%">

                      <div class="card-body">
                        <h5 class="card-title  title-banner title preto-geia l-s-0 title-card-seguros"><b>SEGURO
                            RESIDENCIAL</b></h5>
                      </div>
                      <img src="../../../../assets/app-assets/images/icones-geia/varejo/home.png" alt=""
                        class="card-img-icon mx-auto img-top-card  img-fluid  img-top">
                      <div class="card-body">
                        <p class="card-text text-center desc-text-card-price">Proteção e
                          assistência
                          para
                          sua residência. </p>
                        <h5 class="card-title text-center  "><b>Faça sua cotação!</b></h5>

                        <div class="justify-content-center ">
                          <span class="desc-price-top-seguro">A partir
                            de</span>
                          <h2 class="card-price-center">
                            {{26}}<span class=" cent-value">,{{41}}</span>
                          </h2>
                          <div class="text-center" style="margin-top: -18px">
                            <span class=" desc-mount mb-2" style=" margin-left: -16px !important;">Em 4
                              x</span>
                          </div>
                        </div>

                        <div class="d-flex justify-content-center">

                          <button type="button" (click)="cotacaoOnline(template,'RESIDENCIAL')"
                            class="btn btn-info  cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1"><b>COTAÇÃO
                              ONLINE</b></button>
                        </div>
                      </div>
                    </div>
                    <div class="card   shadow-card " style="width:60%">
                      <div class="card-body">
                        <h5 class="card-title title-banner title preto-geia l-s-0 title-card-seguros">
                          <b>SEGURO
                            AUTO</b>
                        </h5>
                      </div>
                      <img src="../../../../assets/app-assets/images/icones-geia/varejo/car.png" alt="car"
                        class="card-img-icon mx-auto img-top   img-fluid ">
                      <div class="card-body">
                        <p class="card-text text-center desc-text-card-price">Aqui seu veículos está em
                          boas mãos. </p>
                        <h5 class="card-title text-center  "><b>Faça sua cotação!</b></h5>

                        <div class="justify-content-center ">
                          <span class="desc-price-top-seguro">A partir
                            de</span>
                          <h2 class="card-price-center">
                            {{70}}<span class=" cent-value">,{{24}}</span>
                          </h2>
                          <div class="text-center" style="margin-top: -18px">
                            <span class=" desc-mount mb-2" style=" margin-left: -16px !important;">por mês</span>
                          </div>
                        </div>

                        <div class="d-flex justify-content-center">
                          <button type="button" (click)="cotacaoOnline(template,'AUTO')"
                            class="btn btn-info  cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1"><b>COTAÇÃO
                              ONLINE</b></button>
                        </div>
                      </div>
                    </div>
                    <div class="card  shadow-card   " style="width:60%">
                      <div class="card-body">
                        <h5 class="card-title  title-banner title preto-geia l-s-0 title-card-seguros"><b>SEGURO
                            VIAGEM</b></h5>
                      </div>
                      <img src="../../../../assets/app-assets/images/icones-geia/varejo/mapa-pin.png" alt="mapa pin"
                        class="card-img-icon mx-auto  img-top img-fluid ">
                      <div class="card-body">
                        <p class="card-text text-center desc-text-card-price">Aproveite cada momento com
                          toda segurança.</p>
                        <h5 class="card-title text-center  "><b>Faça sua cotação!</b></h5>

                        <div class="justify-content-center ">
                          <span class="desc-price-top-seguro">A partir
                            de</span>
                          <h2 class="card-price-center">
                            {{21}}<span class=" cent-value">,{{71}}</span>
                          </h2>
                          <div class="text-center" style="margin-top: -18px">
                            <span class=" desc-mount mb-2" style=" margin-left: -16px !important;">
                            </span>
                          </div>
                        </div>

                        <div class="d-flex justify-content-center">
                          <button type="button" (click)="cotacaoOnline(template,'VIAGEM')"
                            class="btn btn-info  cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1"><b>COTAÇÃO
                              ONLINE</b></button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

              <div class="carousel-item">
                <div class="d-none d-lg-block d-md-block">
                  <div class="cards-wrapper">
                    <div class="card  shadow-card " style="width:60%">
                      <div class="card-body">
                        <h5 class="card-title  title-banner title preto-geia l-s-0 title-card-seguros"><b>SEGURO
                            CAMINHÃO</b></h5>
                      </div>
                      <img src="../../../../assets/app-assets/images/icones-geia/varejo/caminhao.png" alt=" "
                        class="card-img-icon img-top  mx-auto   img-fluid ">
                      <div class="card-body">
                        <p class="card-text text-center desc-text-card-price">Aqui seu caminhão ou frota está em boas
                          mãos.</p>
                        <h5 class="card-title text-center  ">
                          <!-- <b>Faça sua cotação!</b> -->
                        </h5>

                        <div class="justify-content-center ">
                          <span class="desc-price-top-seguro">
                            <!-- A partir  de -->
                          </span>
                          <h2 class="card-price-center" style="
                                font-size: 15px;
    line-height: 28px;
    padding-bottom: 41px;">
                            <!-- {{00}}<span class=" cent-value">,00 </span> -->
                            Faça sua cotação online
                            sem compromisso!
                          </h2>
                          <div class="text-center" style="margin-top: -18px">
                            <span class=" desc-mount mb-2" style=" margin-left: -16px !important;">
                              <!-- por mês -->
                            </span>
                          </div>
                        </div>

                        <div class="d-flex justify-content-center">
                          <button type="button" (click)="cotacaoOnline(template,'CAMINHAO')"
                            class="btn btn-info  cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1"><b>COTAÇÃO
                              ONLINE</b></button>
                        </div>
                      </div>
                    </div>
                    <div class="card  shadow-card   " style="width:60%">
                      <div class="card-body">
                        <h5 class="card-title  title-banner title preto-geia l-s-0 title-card-seguros"><b>SEGURO
                            MOTO</b></h5>
                      </div>
                      <img src="../../../../assets/app-assets/images/icones-geia/varejo/moto.png" alt=""
                        class="card-img-icon img-top mx-auto   img-fluid ">
                      <div class="card-body">
                        <p class="card-text text-center desc-text-card-price">
                          Aqui sua motocicleta está em boas mãos.</p>
                        <h5 class="card-title text-center  "><b>Faça sua cotação!</b></h5>

                        <div class="justify-content-center ">
                          <span class="desc-price-top-seguro">A partir
                            de</span>
                          <h2 class="card-price-center">
                            {{120}}<span class=" cent-value">,00</span>
                          </h2>
                          <div class="text-center" style="margin-top: -18px">
                            <span class=" desc-mount mb-2" style=" margin-left: -16px !important;">por
                              mês</span>
                          </div>
                        </div>

                        <div class="d-flex justify-content-center">
                          <button type="button" (click)="cotacaoOnline(template,'MOTO')"
                            class="btn btn-info  cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1"><b>COTAÇÃO
                              ONLINE</b></button>
                        </div>
                      </div>
                    </div>
                    <div class="card  shadow-card    " style="width:60%">
                      <div class="card-body">
                        <h5 class="card-title  title-banner title preto-geia l-s-0 title-card-seguros"><b>SEGURO
                            DE VIDA</b></h5>
                      </div>
                      <img src="../../../../assets/app-assets/images/icones-geia/varejo/coracao.png" alt=" "
                        class="card-img-icon img-top mx-auto img-top img-fluid ">
                      <div class="card-body">
                        <p class="card-text text-center desc-text-card-price">Aproveite cada momento com
                          toda segurança</p>
                        <h5 class="card-title text-center  "><b>Faça sua cotação!</b></h5>

                        <div class="justify-content-center ">
                          <span class="desc-price-top-seguro">A partir
                            de</span>
                          <h2 class="card-price-center">
                            {{35}}<span class=" cent-value">,{{79}}</span>
                          </h2>
                          <div class="text-center" style="margin-top: -18px">
                            <span class=" desc-mount mb-2" style=" margin-left: -16px !important;">
                            </span>
                          </div>
                        </div>

                        <div class="d-flex justify-content-center">
                          <button type="button" (click)="cotacaoOnline(template,'VIDA')"
                            class="btn btn-info  cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1"><b>COTAÇÃO
                              ONLINE</b></button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
            <a class="carousel-control-prev d-none d-lg-block d-md-block" href="#carousel-seguro" role="button"
              data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next d-none d-lg-block d-md-block" href="#carousel-seguro" role="button"
              data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>

          <!-- <moible -->
          <div id="myCarouselMobile" class="carousel slide mobileCarouselCards" data-interval="false"
            data-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <app-seguro-card-preco titulo="SEGURO RESIDENCIAL"
                  imagemUrl="../../../../assets/app-assets/images/icones-geia/varejo/home.png"
                  descricao="Proteção e assistência para sua residência." preco="26" valorCentavo="41" parcelas="Em 4x"
                  cotacaoTipo="RESIDENCIAL" (cotacaoOnlineClick)="cotacaoOnline(template,'RESIDENCIAL')">
                </app-seguro-card-preco>
              </div>
              <div class="carousel-item">
                <app-seguro-card-preco titulo="SEGURO AUTO"
                  imagemUrl="../../../../assets/app-assets/images/icones-geia/varejo/car.png"
                  descricao="Aqui seu veículos está em boas mãos." preco="70" valorCentavo="24" parcelas="Por mês"
                  cotacaoTipo="AUTO" (cotacaoOnlineClick)="cotacaoOnline(template,'AUTO')">
                </app-seguro-card-preco>
              </div>
              <div class="carousel-item">
                <app-seguro-card-preco titulo="SEGURO VIAGEM"
                  imagemUrl="../../../../assets/app-assets/images/icones-geia/varejo/mapa-pin.png"
                  descricao="Aproveite cada momento com  toda segurança." preco="21" valorCentavo="71" parcelas=""
                  cotacaoTipo="VIAGEM" (cotacaoOnlineClick)="cotacaoOnline(template,'VIAGEM')">
                </app-seguro-card-preco>

              </div>
              <div class="carousel-item">
                <app-seguro-card-preco titulo="SEGURO CAMINHÃO"
                  imagemUrl="../../../../assets/app-assets/images/icones-geia/varejo/caminhao.png" preco="Faça sua cotação online
                  sem compromisso!" [isCaminhao]=true descricao="Aqui seu caminhão ou frota está em boas
                  mãos." cotacaoTipo="CAMINHAO" (cotacaoOnlineClick)="cotacaoOnline(template,'CAMINHAO')">
                </app-seguro-card-preco>
              </div>
              <div class="carousel-item">

                <app-seguro-card-preco titulo="SEGURO MOTO"
                  imagemUrl="../../../../assets/app-assets/images/icones-geia/varejo/moto.png"
                  descricao=" Aqui sua motocicleta está em boas mãos." preco="120" valorCentavo="00" parcelas="por  mês"
                  cotacaoTipo="MOTO" (cotacaoOnlineClick)="cotacaoOnline(template,'MOTO')">
                </app-seguro-card-preco>
              </div>
              <div class="carousel-item">
                <app-seguro-card-preco titulo="SEGURO DE VIDA"
                  imagemUrl="../../../../assets/app-assets/images/icones-geia/varejo/coracao.png" descricao="Aproveite cada momento com
                  toda segurança" preco="35" valorCentavo="79" parcelas="por  mês" cotacaoTipo="VIDA"
                  (cotacaoOnlineClick)="cotacaoOnline(template,'VIDA')">
                </app-seguro-card-preco>

              </div>

              <a class="carousel-control-prev" href="#myCarouselMobile" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#myCarouselMobile" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
          <!--  -->
        </div>
      </div>

    </div>
  </div>

  <ng-template #template>

    <div class="modal-header">
      <h5 class="modal-title"> {{tituloSimulacao}}</h5>
      <button (click)="decline()" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true"><i class="fa fa-times">
          </i></span>
      </button>
    </div>

    <div class="modal-body text-center">
      <iframe [src]="urlIframe" width="100%" height="500" frameborder="0"></iframe>
    </div>
    <!-- <div class="modal-footer">
      <button (click)="decline()" type="button" class="btn btn-warning round box-shadow-4 "><i class="fa fa-times">
        </i> FECHAR </button>

    </div> -->
  </ng-template>
</section>